import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { MinStdOpenModalForm } from '@/module/MinimalStandard/components/MinStdOpenModalForm';

import { IdentityRequest, useAppNotification } from '@feature/utils';

import { useMinStdOpen } from '../model/MinStdQuery';

export function OpenMinStdButton() {
  const { mutate, isPending } = useMinStdOpen();
  const { t } = useTranslation();

  const [formOpened, { open: openForm, close: closeForm }] = useDisclosure(false);

  const notification = useAppNotification();
  const onSubmit = (values: { minStdAnnexNo: IdentityRequest }) => {
    mutate(
      { minStdAnnexNo: values.minStdAnnexNo.id },
      {
        onSuccess: () => {
          notification.success();
          closeForm();
        },
        onError: notification.error,
      },
    );
  };

  return (
    <>
      <Button
        loading={isPending}
        size="xs"
        onClick={openForm}
      >
        {t('minStd.selectAnnex')}
      </Button>
      {formOpened && (
        <MinStdOpenModalForm
          onSubmit={onSubmit}
          isSubmitting={isPending}
          onClose={closeForm}
        />
      )}
    </>
  );
}
